﻿import * as React from 'react';
import { Button, Panel } from 'react-bootstrap';

type RetrieveOrderPanelLabels = {
    title: string;
    description: string;
    buttonText: string;
};

type RetrieveOrderPanelProps = {
    labels: RetrieveOrderPanelLabels;
    orderId: number;
    onRetrieveOrder: () => Promise<void>;
};

function RetrieveOrderPanel({ labels, onRetrieveOrder }: RetrieveOrderPanelProps) {
    function handleClickRetrieveOrder() {
        onRetrieveOrder();
    }

    return (
        <Panel>
            <Panel.Heading>
                <Panel.Title>{<div>{labels.title}</div>}</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
                <div className="retrieveOrder__container">
                    <span className="retrieveOrder__description">{labels.description}</span>
                    <div className="retrieveOrder__spacer" />
                    <Button bsStyle="primary" onClick={handleClickRetrieveOrder}>
                        {labels.buttonText}
                    </Button>
                </div>
            </Panel.Body>
        </Panel>
    );
}

export default RetrieveOrderPanel;
